module.exports = {
  id: 22,
  name: 'Rabbit Hops',
  categories: ['cardio', 'legs', 'coordination'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'beginner',
  skill: 'Coordination',
  points: 11,
  instructions:
    'Rabbit Hops make you bouncy like a rabbit! Stand with your feet together, bend your knees, then hop forward with both feet together like a rabbit!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to hop like a rabbit? Let us build incredible coordination!',
    },
    {
      time: 3,
      text: 'Stand with your feet together, bend your knees!',
    },
    {
      time: 6,
      text: 'Get ready to hop forward with both feet together!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Hop forward like a rabbit!',
    },
    // SET 1 - 10 hops
    {
      time: 12,
      text: 'Perfect rabbit position! Feet together, knees bent!',
    },
    {
      time: 15,
      text: 'Number 1! Hop forward with both feet together!',
    },
    {
      time: 18,
      text: 'Land softly and bend your knees to absorb the impact!',
    },
    {
      time: 21,
      text: 'Number 2! Hop forward like a rabbit, you are doing great!',
    },
    {
      time: 24,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 27,
      text: 'Number 3! Hop forward with both feet together!',
    },
    {
      time: 30,
      text: 'Land softly and bend your knees, stay focused!',
    },
    {
      time: 33,
      text: 'Number 4! Hop forward like a rabbit, keep going!',
    },
    {
      time: 36,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 39,
      text: 'Number 5! Hop forward with both feet together!',
    },
    {
      time: 42,
      text: 'Land softly and bend your knees, you are strong!',
    },
    {
      time: 45,
      text: 'Number 6! Hop forward like a rabbit, you are doing great!',
    },
    {
      time: 48,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 51,
      text: 'Number 7! Hop forward with both feet together!',
    },
    {
      time: 54,
      text: 'Land softly and bend your knees, stay focused!',
    },
    {
      time: 57,
      text: 'Number 8! Hop forward like a rabbit, keep going!',
    },
    {
      time: 60,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 63,
      text: 'Number 9! Hop forward with both feet together!',
    },
    {
      time: 66,
      text: 'Land softly and bend your knees, you are strong!',
    },
    {
      time: 69,
      text: 'Number 10! Hop forward like a rabbit, almost there!',
    },
    {
      time: 72,
      text: 'Land softly and bend your knees, incredible work!',
    },
    {
      time: 75,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 78,
      text: 'Take a deep breath in and out, you are building incredible coordination!',
    },
    {
      time: 81,
      text: 'Shake out your legs and feet, get ready for round two!',
    },
    {
      time: 84,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 87,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 2 - 10 hops
    {
      time: 90,
      text: 'Stand with your feet together, bend your knees!',
    },
    {
      time: 93,
      text: 'Get ready to hop forward with both feet together!',
    },
    {
      time: 96,
      text: 'Perfect rabbit position! Hop forward like a rabbit!',
    },
    {
      time: 99,
      text: 'Number 1! Hop forward with both feet together!',
    },
    {
      time: 102,
      text: 'Land softly and bend your knees to absorb the impact!',
    },
    {
      time: 105,
      text: 'Number 2! Hop forward like a rabbit, you are doing great!',
    },
    {
      time: 108,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 111,
      text: 'Number 3! Hop forward with both feet together!',
    },
    {
      time: 114,
      text: 'Land softly and bend your knees, stay focused!',
    },
    {
      time: 117,
      text: 'Number 4! Hop forward like a rabbit, keep going!',
    },
    {
      time: 120,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 123,
      text: 'Number 5! Hop forward with both feet together!',
    },
    {
      time: 126,
      text: 'Land softly and bend your knees, you are strong!',
    },
    {
      time: 129,
      text: 'Number 6! Hop forward like a rabbit, you are doing great!',
    },
    {
      time: 132,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 135,
      text: 'Number 7! Hop forward with both feet together!',
    },
    {
      time: 138,
      text: 'Land softly and bend your knees, stay focused!',
    },
    {
      time: 141,
      text: 'Number 8! Hop forward like a rabbit, keep going!',
    },
    {
      time: 144,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 147,
      text: 'Number 9! Hop forward with both feet together!',
    },
    {
      time: 150,
      text: 'Land softly and bend your knees, you are strong!',
    },
    {
      time: 153,
      text: 'Number 10! Hop forward like a rabbit, almost there!',
    },
    {
      time: 156,
      text: 'Land softly and bend your knees, incredible work!',
    },
    {
      time: 159,
      text: 'Great job! Take a deep breath and shake out your legs.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 162,
      text: 'Take a deep breath in and out, you are building incredible coordination!',
    },
    {
      time: 165,
      text: 'Shake out your legs and feet, get ready for the final round!',
    },
    {
      time: 168,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 171,
      text: '3, 2, 1, START! Remember the form!',
    },
    // SET 3 - 10 hops
    {
      time: 174,
      text: 'Stand with your feet together, bend your knees!',
    },
    {
      time: 177,
      text: 'Get ready to hop forward with both feet together!',
    },
    {
      time: 180,
      text: 'Perfect rabbit position! Hop forward like a rabbit!',
    },
    {
      time: 183,
      text: 'Number 1! Hop forward with both feet together!',
    },
    {
      time: 186,
      text: 'Land softly and bend your knees to absorb the impact!',
    },
    {
      time: 189,
      text: 'Number 2! Hop forward like a rabbit, you are doing great!',
    },
    {
      time: 192,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 195,
      text: 'Number 3! Hop forward with both feet together!',
    },
    {
      time: 198,
      text: 'Land softly and bend your knees, stay focused!',
    },
    {
      time: 201,
      text: 'Number 4! Hop forward like a rabbit, keep going!',
    },
    {
      time: 204,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 207,
      text: 'Number 5! Hop forward with both feet together!',
    },
    {
      time: 210,
      text: 'Land softly and bend your knees, you are strong!',
    },
    {
      time: 213,
      text: 'Number 6! Hop forward like a rabbit, you are doing great!',
    },
    {
      time: 216,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 219,
      text: 'Number 7! Hop forward with both feet together!',
    },
    {
      time: 222,
      text: 'Land softly and bend your knees, stay focused!',
    },
    {
      time: 225,
      text: 'Number 8! Hop forward like a rabbit, keep going!',
    },
    {
      time: 228,
      text: 'Land softly and get ready for the next hop!',
    },
    {
      time: 231,
      text: 'Number 9! Hop forward with both feet together!',
    },
    {
      time: 234,
      text: 'Land softly and bend your knees, you are strong!',
    },
    {
      time: 237,
      text: 'Number 10! Hop forward like a rabbit, almost there!',
    },
    {
      time: 240,
      text: 'Land softly and bend your knees, incredible work!',
    },
    {
      time: 243,
      text: 'Incredible work! You are done! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 246,
      text: 'Amazing work! You did 30 rabbit hops and built incredible coordination!',
    },
    {
      time: 249,
      text: 'You are getting super bouncy and coordinated! You are a rabbit master!',
    },
    {
      time: 252,
      text: 'Great job, coordination champion! You are building incredible skills!',
    },
  ],
};
